import React from 'react';
import PropTypes from 'prop-types';

import { extractFormatsFromPattern, megabytesToBytes } from '../../helpers/fileUtils';

import MultiFileInput from '../../design-system/MultiFileInput/MultiFileInput';

const MultiFileInputType = ({
    value,
    constraints,
    state,
    placeholder = 'Drag & drop a file to upload or click to browse',
    handleChange,
}) => {
    const acceptedFormats = extractFormatsFromPattern(constraints?.pattern);
    const maxFileSize = megabytesToBytes(constraints?.max);
    const minFileSize = megabytesToBytes(constraints?.min);

    const handleFile = (file) => {
        handleChange((item) => ({ ...item, value: file }));
    };

    return (
        <MultiFileInput
            files={value}
            state={state}
            formatsArray={acceptedFormats}
            maxSizeInBytes={maxFileSize}
            minSizeInBytes={minFileSize}
            handleFiles={handleFile}
            placeholder={placeholder}
        />
    );
};

MultiFileInputType.propTypes = {
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string])),
    constraints: PropTypes.object,
    state: PropTypes.oneOf(['default', 'disabled', 'error']),
    placeholder: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
};

export default MultiFileInputType;
